<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 id="title-redirect">{{ 'resume.ok.text' | translate:{NB_DOCUMENTS: documents.length} }}</h2>

    <section class="infoBox">
        <p id="info-box-signed-mail" [hidden]="!mail()">{{ 'resume.infoBoxWithEmail' |
            translate:{NB_DOCUMENTS: documents.length} }}</p>
        <p id="info-box-signed" [hidden]="mail()">{{ 'resume.infoBox' | translate:{NB_DOCUMENTS: documents.length} }}</p>
        <p id="info-box-multiple" *ngIf="documents.length >1">{{ ('end.content.summary'
            | signatureAction: hasTrueSignature ? 'SIGNATURE' : 'APPROVAL') | translate:{NB_DOCUMENTS: documents.length} }}</p>
    </section>

    <section class="infoBox">
        <p id="info-box-redirect">{{ 'redirection.info' | translate }}</p>
    </section>

</main>